export interface IPointCreator {
  x: number;
  y: number;
  planId: number;
}

export class PointCreator implements IPointCreator {
  x: number;
  y: number;
  planId: number;

  constructor(x: number, y: number, planId: number) {
    this.x = x;
    this.y = y;
    this.planId = planId;
  }
}
